"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LookbookModal = void 0;
const utils_1 = require("../../utils/utils");
const modal_1 = require("../../components/modal/modal");
const LOOKBOOK_SELECTOR = 'lookbook-component';
class LookbookModal extends modal_1.ModalComponent {
    async show() {
        await super.show();
        const lookbook = (0, utils_1.$elParent)(LOOKBOOK_SELECTOR, this);
        lookbook?.showBlockById(lookbook.selectedPinId);
    }
}
exports.LookbookModal = LookbookModal;
